import { useState } from "react";
import CampoDate from "../../../components/Campo/CampoDate";
import CampoSelect from "../../../components/Campo/CampoSelect";
import CampoTextoLongo from "../../../components/Campo/CampoTextoLongo";
import styles from "./styles.module.css";
import CampoAnexo from "../../../components/Campo/CampoAnexo";
import { TipoPrestacaoDeContas } from "../../../enums/TipoPrestacaoDeContas";

const CumprimentoObjetivo = () => {
  const [tipoPrestacao, setTipoPrestacao] = useState("");
  const [introducao, setIntroducao] = useState("");
  const [demonstracaoAlcance, setDemonstracaoAlcance] = useState("");
  const [acoesDesenvolvidas, setAcoesDesenvolvidas] = useState("");
  const [documentosComprovacoes, setDocumentoComprovacoes] = useState<
    (File | undefined)[] | null
  >([undefined]);
  const [informacaoesAdicionais, setInformacoesAdicionais] = useState("");
  const [consideracoesFinais, setConsideracoesFinais] = useState("");
  const [inicio, setInicio] = useState(new Date(Date.now()));
  const [fim, setFim] = useState(new Date(Date.now()));
  return (
    <form className={styles.formCadastro} onSubmit={(e) => e.preventDefault()}>
      <div>
        <h2 className={styles.titulo}>
          1. Relatório de Cumprimento de <strong>Objetivo</strong>:
        </h2>
      </div>
      <div className={styles.gridCampos}>
        <CampoSelect
          title="Tipo de Prestação de Contas"
          setter={setTipoPrestacao}
          value={tipoPrestacao}
        >
          <option value={TipoPrestacaoDeContas.parcial}>Parcial</option>
          <option value={TipoPrestacaoDeContas.final}>Final</option>
        </CampoSelect>

        <div className={styles.gridCampos}>
          <CampoDate
            title="Inicio"
            showAsterisk
            customValidity="A data de inicio deve ser uma data valida e estar no passadp"
            max={new Date(Date.now()).toISOString().split("T")[0]}
            setter={setInicio}
            value={inicio}
          />
          <CampoDate
            title="Fim"
            showAsterisk
            customValidity="A data de Fim deve ser uma data valida, posterior a data de Inicio e estar no passado"
            max={new Date(Date.now()).toISOString().split("T")[0]}
            setter={setFim}
            value={fim}
          />
        </div>
      </div>
      <CampoTextoLongo
        title="Introdução"
        placeholder="Preencha com a introdução á prestação de contas"
        required={true}
        customValidity="Preencha com a introdução á prestação de contas"
        setter={setIntroducao}
        value={introducao}
      />
      <CampoTextoLongo
        title="Demonstração do Alcance das Metas"
        placeholder="Demonstre como as metas foram alcançadas"
        required={true}
        customValidity="Preencha com a Demonstração de Alcance das Metas"
        setter={setDemonstracaoAlcance}
        value={demonstracaoAlcance}
      />

      <CampoTextoLongo
        title="Ações desenvolvidas"
        placeholder="Descreva as Ações desenvolvidas"
        required={true}
        customValidity="Preencha com as Ações desenvolvidas ao longo do periodo"
        setter={setAcoesDesenvolvidas}
        value={acoesDesenvolvidas}
      />
      <CampoTextoLongo
        title="Informações Adicionais"
        placeholder="Preencha com quaisquer Informações adicionais a respeito da prestação de contas"
        setter={setInformacoesAdicionais}
        value={informacaoesAdicionais}
      />
      <CampoTextoLongo
        title="Considerações Finais"
        placeholder="Preencha com quaisquer Considerações finais"
        setter={setConsideracoesFinais}
        value={consideracoesFinais}
      />
      <CampoAnexo
        title="Documentos Comprovação"
        required
        setter={setDocumentoComprovacoes}
        value={documentosComprovacoes}
        lista
      />

      <div className="flex justify-end">
        <button className={styles.passarTelaBtn} onClick={(e) => {}}>
          Salvar e Prosseguir ❯❯
        </button>
      </div>
    </form>
  );
};
export default CumprimentoObjetivo;
